import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { ContentViewTypes } from '../content-view/content-view.component';
import { ActivatedRoute } from '@angular/router';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-session-page',
  templateUrl: './session-page.component.html',
  styleUrl: './session-page.component.scss'
})

export class SessionPageComponent implements OnInit, OnChanges {

  @Input() trainingType: string = 'WEEKLY'
  @Input() branchId !: string
  @Input() companyID !: string
  @Input() allowedSessions: string[] = []
  @Input() sessionFormData: any
  @Input() recreate : boolean = false
  @Input() isHistory: boolean = false
  @Input() isCertAdd: boolean = false
  @Input() trainingDate: any = [new Date('3/7/2024'), new Date('3/8/2024')]
  @Output() sessionData: EventEmitter<any> = new EventEmitter()
  sessionForm !: FormGroup;
  externalTrainers: any[] = [];
  internalTrainers: any[] = [];
  trainers: any[] = [];
  city: Array<Location | any> = [];
  trainerType: any
  UpdateTrainer: boolean = true
  addTrainerModal: boolean = false
  sessionType!:string 
  trainingMaterialImageType = ImageTypes.training_material
  addedVideoContentType: ContentViewTypes = ContentViewTypes.Video
  addedImageContentType: ContentViewTypes = ContentViewTypes.Image
  from: string = '';
  external: boolean = false;
  certificateData:any = {
    certTopText: this.translate("DefaultCertAttendanceTop"),
    certMiddleText: this.translate("DefaultCertAttendanceMiddle"),
    certBottom1Text: this.translate("DefaultCertAttendanceBottom"),
    certBottom2Text: this.translate("DefaultCertAttendanceBottom2"),
    certBottom3Text: this.translate("DefaultCertAttendanceBottom3"),
    managerName: this.translate("Manager Name"),
    partnerName: this.translate("Partner Name"),
  };

  blockOptions: any[] = [
    { name: this.translate('Preview status'), value: 'Preview' },
    { name: this.translate('Block status'), value: 'Block' },
    { name: this.translate('Unblock status'), value: 'Unblock' }
  ];


  translate(value: string) {
    const pipe: TranslatorPipe = new TranslatorPipe();
    return pipe.transform(value);
  }




  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    public permissionService: PermissionHandlerService,
    private activatedRoute: ActivatedRoute
  ) { }


  ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(e => {
      this.from = e['from'];

      console.log("this.from",this.from)
      this.createSessionForm()
      console.log('ALLOWED SESSIONS', this.allowedSessions);
      Promise.all([
        this.getCity(),
        this.getTrainers()
      ])

      if(this.isCertAdd)
      {
        this.sessionForm.get('sessionType')?.setValue('Certificate');
      }
    })

    let rawType = localStorage.getItem('externalUser')
    if (rawType) {
      this.external = JSON.parse(rawType).status;
    }
  }

  hasPermission(unit:string,flag:string){
    return this.permissionService.hasPermission(unit, flag)
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  dateValidate(values: Date) {
    let selectedDate = new Date(values.getFullYear(), values.getMonth(), values.getDate(), 0, 0, 0)
    const startDate = this.trainingDate[0];
    const endDate = this.trainingDate[1];
    //if selected date is greater than start date      //if selected date is less than end date
    if ((selectedDate.getTime() < startDate.getTime()) || (selectedDate.getTime() > endDate.getTime())) {
      this.clearValues(['date'])
    }

  }

  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  isExternalTrainerAllowed() {
    let notAllowExternalUsers: Array<String> = ['WEEKLY', 'Unified session']
    return !notAllowExternalUsers.includes(this.trainingType)
  }


  checkTrainerAvailability = async () => {
    try {

      if (this.sessionType == 'Video') {
        return
      }

      let sessionData = this.sessionForm.getRawValue()

      if (!sessionData.trainer.user_id || !sessionData.end_time || !sessionData.start_time || !sessionData.date) {
        this.clearValues(['trainer'])
        this.sessionForm.get('trainer')?.setErrors({ requestError: true })
        return
      }

      let query: any = {
        trainerId: sessionData.trainer.user_id,
        date: sessionData.date,
        start_time: sessionData.start_time,
        end_time: sessionData.end_time
      }

      if(!!this.sessionFormData?._id){
        query.sessionId = this.sessionFormData._id
      }

      let res = await this.dataService.postData('session/check-trainer-availability', query)
      if (res.error) {
        this.clearValues(['trainer'])
        return
      }
      if (res.data[0].busy) {
        this.clearValues(['trainer'])
        this.sessionForm.get('trainer')?.setErrors({ customError: true })
      }

      return

    } catch (error) {
      console.log(error)
    }
  };

  changeUpdateTrainer(value: boolean) {
    this.UpdateTrainer = value
    this.cdr.detectChanges();
  }

  getTrainers = async () => {
    if (this.trainingType == 'Unified session' || this.trainingType == 'WEEKLY') {
      await this.getInternalTrainers()
    }
    else {
      await this.getInternalTrainers()
      await this.getExternalTrainers()
    }

    if (this.from == "Manager") {
      let rawType = localStorage.getItem('externalUser')
      if (rawType) {
        this.external = JSON.parse(rawType).status;
        
        this.trainers = this.external ? this.externalTrainers : this.internalTrainers;
      }
    } else {
      this.trainers = !this.isExternalTrainerAllowed() ? this.internalTrainers : this.externalTrainers
      
      if(!this.external) this.trainers = this.internalTrainers
      
    }
  };

  showInternal : boolean = true

  internalExternal(type: any) {
    if (type.checked == false) {
      this.trainers = this.internalTrainers
      this.showInternal = true
    }
    if (type.checked == true) {
      this.trainers = this.externalTrainers
      this.showInternal = false
    }
  }

  getExternalTrainers = async () => {
    try {
      
      let query: any = {
        'externalUser.status': { '$eq': true },
        'externalUser.role': 'trainer',
        'externalUser.company': this.companyID
      }

      if(!this.companyID){
        delete query['externalUser.company']
      }

      

      let res = await this.dataService.postData('user/get', query);
      if (res.error) return
      this.externalTrainers = res?.data.map((item: any) => {
        let name = `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last}`
        if (item?.externalUser?.company?.name) {
          name = `${name}  (${item?.externalUser?.company?.name})`
        }
        return {
          name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last} ${this.trainingType == 'Skill Training' && item?.externalUser?.company?.name ? `( ${item?.externalUser?.company?.name ? item?.externalUser?.company?.name : ''} )` : ''} `,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email
        }
      });
    } catch (error) {
      console.log(error)
    }
  }

  getInternalTrainers = async () => {
    try {
      let query: any = {
        'externalUser.status': { $ne: true },
        'externalUser.role': 'trainer'
      }

      if (this.branchId && this.trainingType != 'New Branch') {
        query.ou = this.branchId
      }

      let res = await this.dataService.postData('user/get', query);
      if (res.error) return

      this.internalTrainers = res?.data.map((item: any) => {
        return {
          name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last}`,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email
        }
      });

    } catch (error) {
      console.log(error)
    }
  }

  async assNewTrainers(list : any){
    if(list.emit == false){
      this.addTrainerModal = false
    }
    const arrayOfIds = list.users.map((obj:any) => obj._id);
    try {
      let res :any = await this.dataService.postData('user/add-trainer',arrayOfIds,'PUT',false);
      if(res.error) {
        return
      }  
      else {
        this.addTrainerModal = false
        this.getInternalTrainers().then(()=>{
          this.trainers = this.internalTrainers
        });
      }
    } catch (error) {
      console.log(error)
    }
  }

  handleUpdatedUserData(event: any) {
    this.getTrainers()
  }

  createSessionForm() {
    this.allowedSessions = this.allowedSessions.filter(e => e != 'Survey' && e != 'Assessment')

    console.log('this.allowedSessions',this.allowedSessions)

    this.sessionForm = this.fb.group({
      title: ['', Validators.required],
      date: ['', Validators.required],
      start_time: ['', Validators.required],
      end_time: ['', Validators.required],
      trainer: ['', Validators.required],
      zoom_url: [''],
      video_url: [''],
      video_mode: ['Unblock'],
      sessionType: ['', Validators.required],
      address: ['', Validators.required],
      city: ['', Validators.required],
      locationLink: ['', Validators.required],
      history: [''],
      certTopText: [this.certificateData.certTopText, Validators.required],
      certMiddleText: [this.certificateData.certMiddleText, Validators.required],
      certBottom1Text: [this.certificateData.certBottom1Text, Validators.required],
      certBottom2Text: [this.certificateData.certBottom2Text, Validators.required],
      certBottom3Text: [this.certificateData.certBottom3Text, Validators.required],
      managerName: ['', Validators.required],
      partnerName: ['', Validators.required],
      logo_img: [''],
      sign_image: [''],
    });

    // Subscribe to value changes of date, start_time, and end_time controls
    this.sessionForm.get('date')?.valueChanges.subscribe(() => {
      this.sessionForm?.get('trainer')?.reset();
      this.changeUpdateTrainer(true)
    });

    this.sessionForm?.get('start_time')?.valueChanges.subscribe(() => {
      this.sessionForm.get('trainer')?.reset();
      this.changeUpdateTrainer(true)
    });

    this.sessionForm.get('end_time')?.valueChanges.subscribe(() => {
      this.sessionForm.get('trainer')?.reset();
      this.changeUpdateTrainer(true)
    });


    // Set up conditional validators based on sessionType
    this.sessionForm?.get('sessionType')?.valueChanges.subscribe(value => {
      if (value === 'Online') {
        this.setValidators(['title', 'date', 'start_time', 'end_time', 'zoom_url', 'trainer']);
        this.clearValidators(['video_url', 'address', 'city', 'locationLink','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
        this.clearValues(['video_url', 'address', 'city', 'locationLink','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
      } else if (value === 'Onsite') {
        this.setValidators(['title', 'date', 'start_time', 'end_time', 'trainer', 'address', 'city', 'locationLink']);
        this.clearValidators(['zoom_url', 'video_url','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
        this.clearValues(['zoom_url', 'video_url','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
      } else if (value === 'Video') {
        this.setValidators(['title', 'video_url']);
        this.clearValidators(['start_time', 'end_time','date', 'trainer','zoom_url', 'address', 'city', 'locationLink','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
        this.clearValues(['start_time', 'end_time', 'zoom_url', 'address', 'city', 'locationLink','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','partnerName','logo_img','sign_image']);
      } else if (value === 'Certificate') {
        this.setValidators(['title','certTopText','certMiddleText','certBottom1Text','certBottom2Text','certBottom3Text','managerName','sign_image']);
        this.clearValidators(['start_time', 'end_time','date', 'trainer','zoom_url', 'address', 'city', 'locationLink','video_url','partnerName','logo_img']);
        this.clearValues(['start_time', 'end_time', 'zoom_url', 'address', 'city', 'locationLink','video_url']);
      }
      // Update the validity status of the form after setting/clearing validators
      this.sessionForm?.updateValueAndValidity();
      
      this.sessionType = value

    });



    if (this.sessionFormData) {
      this.UpdateTrainer = false
      this.sessionFormData.date = new Date(this.sessionFormData?.date)
      this.sessionForm.patchValue(this.sessionFormData);
      let data = this.sessionForm.getRawValue()
 
    } 

  }

  setValidators(fields: string[]) {
    fields.forEach(field => {
      const control = this.sessionForm.get(field);
      if (control) {
        control.setValidators(Validators.required);
        control.updateValueAndValidity();
      }
    });
  }

  clearValidators(fields: string[]) {
    fields.forEach(field => {
      const control = this.sessionForm.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  clearValues(fields: string[]) {
    fields.forEach(field => {
      const control = this.sessionForm.get(field);
      if (control) {
        control.setValue(null);
      }
    });
  }

  getVideoUrl(control: string) {
    let url = this.sessionForm.get(control)?.value
    if (url) {
      if (this.isYouTubeUrl(url)) {
        const videoIdMatch = url.match(/[?&]v=([^&]+)/);
        this.addedVideoContentType = ContentViewTypes.YTVideo;
        return videoIdMatch ? videoIdMatch[1] : null;
      } else {
        this.addedVideoContentType = ContentViewTypes.Video;
        return url;
      }
    }
    return '';
  }

  isYouTubeUrl(url: string): boolean {
    const youtubeRegex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
    return youtubeRegex.test(url);
  }

  isFieldError(field: string) {
    const control = this.sessionForm?.get(field);
    if (control?.dirty && control?.touched && control?.errors?.['required']) {
      return true
    }
    return false
  }

  materialUploadResponse(res: any, control: string) {
    console.log(typeof res == 'string', res)
    if (typeof res == 'string') {
      this.sessionForm.controls[control].setValue(GlobalConstants.staticFilesURL + res);
    }
  }

  markAllFieldsTouchedAndDirty(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  disableDates(values: any) {
    let selectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)

    const startDate = this.trainingDate[0];
    const endDate = this.trainingDate[1];
    return !((selectedDate.getTime() >= startDate.getTime()) && (selectedDate.getTime() <= endDate.getTime()));
  }

  onSubmit() {
    if (this.sessionForm.valid) {
      let data = this.sessionForm.getRawValue()
      if (this.sessionFormData &&  !this.recreate) {
        data._id = this.sessionFormData._id
      }
      this.sessionData.emit(data)
      console.log('Form submitted successfully');
      // You can access form values using this.myForm.value
    } else {
      console.log("this.sessionForm",this.sessionForm)
      this.markAllFieldsTouchedAndDirty(this.sessionForm);
      console.error('Form is invalid');
      
    }
  }


}

export enum SessionContentType {
  Online = 'Online',
  Onsite = 'Onsite',
  Video = 'Video',
  Survey = 'Survey',
  Assessment = 'Assessment'
}